// @ts-ignore
/* eslint-disable */
import { BASEURL_USERCENTER } from '@/utils/constant';
import { request } from '@umijs/max';

const token = '123'; // todo

/**  确认邮件预览  */
export async function emailPreview(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<API.opportunityResult>('/email/preview', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/**  发送合同确认邮件  */
export async function sendConfirmedContractEmail(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<API.opportunityResult>('/opportunity/send-confirmed-contract-email', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/**  编辑商机销售阶段描述  */
export async function bussinssDescribe(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<API.opportunityResult>('/business-log/edit-opportunity-describe', {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}

/** 商机跟进 post /installer/opportunity/follow-up-records */
export async function followUpRecords(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<API.opportunityResult>('/opportunity/follow-up-records', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/**记录状态 post /installer/business-log */
export async function businessLog(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<API.opportunityResult>('/business-log', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 跟进记录 post /installer/business-log/list */
export async function businessLogList(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<API.opportunityResult>('/business-log/list', {
    method: 'POST',
    data: body || {},
    ...(options || {}),
  });
}

/** 查询关联订单 **/
export async function getOrderRecord(opportunityId: string) {
  return request<RequestResponse<PagingResponse<OrderRecord[]>>>('/order/record', {
    method: 'POST',
    data: { opportunityId: Number(opportunityId) },
  });
}

export function getContactList(body: { [key: string]: any }) {
  return request<any>('/contact/list', {
    method: 'POST',
    data: body,
  });
}

export function addContact(data: ContactRecord) {
  return request<RequestResponse<PagingResponse<ContactRecord[]>>>('/contact', {
    method: 'POST',
    data: { ...data },
  });
}

export function updateContact(data: ContactRecord) {
  return request<RequestResponse<PagingResponse<ContactRecord[]>>>('/contact/update', {
    method: 'POST',
    data: { ...data },
  });
}
export function deleteContact(id: number) {
  return request<RequestResponse<PagingResponse<ContactRecord[]>>>('/contact/delete', {
    method: 'POST',
    data: { id },
  });
}
/** 商机详情 post /installer/opportunity/detail */
export async function opportunitydetail(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<API.opportunityResult>('/opportunity/detail', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/user/user-info', {
    params: {
      // loginTest: true
    },
    method: 'GET',
    ...(options || {}),
  });
}

export async function getUserPermissions(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/user/isPermissions', {
    baseURL: BASEURL_USERCENTER,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/logout', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function OAUTHLoginOut(body?: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<Record<string, any>>('/idp/profile/OAUTH2/Redirect/GLO', {
    method: 'POST',
    data: body || {},
    ...(options || {}),
  });
}

/** getCookie */
export async function getCookie(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/get-cookie', {
    method: 'GET',
    ...(options || {}),
  });
}
